// Test IDs for the Michele Rago portfolio landing page.
// keys camelCase, values kebab-case `<feature>-<element>`.

export const PROJECTS = {
    section: 'projects-section',
    card: (id) => `project-card-${id}`,
    cta: (id) => `project-cta-${id}`,
};
